<template>
  <project-one-toolbar-tab-layout id="project-one-toolbar-print-sell-sheet" :title="bp('createSellSheet')">
    <p class="text-sm mb-2" v-html="bp('selectFeatures')" />
    <form-group type="checkbox" name="headerOptions" :multi-items="formGroupItems" @change="handleUpdateFormData" />
    <div class="buttons">
      <trek-button
        id="downloadSellSheetButton"
        ref="downloadButton"
        primary
        icon="get_app"
        qaid="download-sell-sheet-button"
        :disabled="isButtonDisabled"
        @click.stop="onSubmit"
      >
        <span v-html="bp('downloadSellSheetPDF')" />
      </trek-button>
    </div>
  </project-one-toolbar-tab-layout>
</template>

<script>
import ProjectOneToolbarTabLayout from '@/projectOne/components/toolbar/components/ProjectOneToolbarTabLayout.vue';
import TrekButton from '@/components/TrekButton';
import FormGroup from '@/components/FormGroup';
import {mapState, mapMutations, mapActions} from 'vuex';
import sellSheetDownload from '@/projectOne/mixins/downloadSellSheet';

export default {
  name: 'ProjectOneToolbarPrintSellSheet',

  components: {
    ProjectOneToolbarTabLayout,
    TrekButton,
    FormGroup,
  },

  mixins: [sellSheetDownload],

  data() {
    return {
      isButtonDisabled: false,
      formGroupItems: [],
    };
  },

  computed: {
    ...mapState('projectOne', ['bikeData', 'selections', 'hasSelectionsChanged']),
  },

  mounted() {
    (this.isButtonDisabled = !this.selections.length),
      (this.formGroupItems = [
        {
          value: 'showHeader',
          displayName: this.bp('includeHeader'),
          checked: this.formData.showHeader,
        },
        {
          value: 'showBikeImage',
          displayName: this.bp('includeImage'),
          checked: this.formData.showBikeImage,
        },
        {
          value: 'showSizingSelections',
          displayName: this.bp('includeSize'),
          checked: this.formData.showSizingSelections,
        },
        {
          value: 'showPricing',
          displayName: this.bp('includePrice'),
          checked: this.formData.showPricing,
        },
      ]);
  },

  methods: {
    handleUpdateFormData(event) {
      this.$set(this.formData, event.currentTarget.id, event.currentTarget.checked);
    },

    async downloadPdf() {
      //   If we have unsaved selection in the vuex, first save them in backoffice and then download the sell sheet
      if (this.hasSelectionsChanged) {
        await this.saveConfig();
      }

      //this is a mixin method
      this.downloadSellSheet();
    },

    onSubmit() {
      this.setDrawerCurrentTabAndOpenState(false);
      if (this.bikeData.code) {
        this.downloadPdf();
      } else {
        this.setOnSaveCallbackFunction(this.downloadPdf);
        this.setIsSaveModalVisible(true);
      }
    },

    ...mapMutations('projectOne', [
      'setIsSaveModalVisible',
      'setPostSaveFunction',
      'setPageLoading',
      'setOnSaveCallbackFunction',
    ]),
    ...mapActions('projectOne', ['setDrawerCurrentTabAndOpenState', 'saveConfig']),
  },
};
</script>
